import { IndexFields } from './index-fields';

export class WebUpload {
  businessAreaId: number = 0;
  docTypeId: number = 0;
  abbyyDocId: number | null = 0;
  queueID: number | null = 0;
  documentType: string = '';
  documentSource: string = '';
  indexFields: IndexFields[] = [];
  documentStream: any | null;
  documentName: string = '';
  sendToWorkflow: boolean = false;
  sendToNewBatch: boolean = false;
  convertToPDF: any | null;
  sendEmailNotification: boolean = false;
  userGpid: string = '';
  systemId: number = 0;
}

export interface WebUploadResponseDto {
  documentId: number | null;
  batchId: number | null;
  workItemId: number | null;
  queueName: string;
  documentName: string;
}

export interface UploadOptionsResponse {
  sizeLimit: string;
  filesLimit: number;
  fileTypes: string;
}
